import { SettingConst } from '@faire/web-api--source/types';

/**
 * The number of cities faire has retailers in, rounded to a nice number we're comfortable disclosing for marketing purposes (e.g. shown on the about us page)
 */
export const FAIRE_RETAILERS_NUMBER_OF_CITIES =
  'FAIRE_RETAILERS_NUMBER_OF_CITIES' as SettingConst<
    'FAIRE_RETAILERS_NUMBER_OF_CITIES',
    number,
    'RETAILER' | 'VISITOR_WEB'
  >;
